module.exports = __webpack_public_path__ + "static/media/uber-raw-data-sep14.c44c091b.csv";